export const INTRO = 0
export const STAGE0 = 1
export const STAGE1 = 2
export const STAGE2_SLOW = 3
export const STAGE2_FAST = 4
export const STAGE2_AIRPORT = 5
export const END_NORMAL = 6

// END SEQUENCE
export const END_START = 7
export const END_SPEED = 8
export const END_BIKE = 9
export const END_LINE = 10

export const RESULTS = 11



// WEBPACK FOOTER //
// ./src/components/game/stages.js